/**
 * Utilitários de Permissões
 * 
 * Constantes e funções auxiliares para trabalhar com permissões no frontend
 */

export const MODULES = {
  ERP: 'erp',
  DASHBOARD: 'dashboard',
  COCKPIT: 'cockpit',
  PRODUCTS: 'products',
  STOCK: 'stock',
  SALES: 'sales',
  QUOTES: 'quotes',
  PEOPLE: 'people',
  FINANCIAL: 'financial',
  SETTINGS: 'settings',
  DIGITAL_CERTIFICATE: 'digital_certificate',
  DOCUMENTS: 'documents',
  ATTENDANCE: 'attendance',
  PROSPECTING: 'prospecting',
  PURCHASES: 'purchases',
  MESSAGES: 'messages',
  REPORTS: 'reports',
  PATIENTS: 'patients',
  DUTY_ROSTERS: 'duty_rosters',
  MY_SHIFTS: 'my_shifts'
}

export const ACTIONS = {
  VIEW: 'view',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  ERP_OPERATIONAL_ASSISTANT: 'operational_assistant',
  PRODUCTS_GROUPS: 'groups',
  PRODUCTS_BRANDS: 'brands',
  PRODUCTS_UNITS: 'units',
  PRODUCTS_IMAGES: 'images',
  PRODUCTS_EDIT_DESCRIPTION: 'edit_description',
  PRODUCTS_EDIT_BRAND: 'edit_brand',
  PRODUCTS_EDIT_GROUP: 'edit_group',
  PRODUCTS_EDIT_CUBAGE: 'edit_cubage',
  PRODUCTS_HIDE_COST: 'hide_cost',
  PRODUCTS_GRIDS: 'grids',
  PRODUCT_REQUEST_VIEW: 'product_request_view',
  PRODUCT_REQUEST_CREATE: 'product_request_create',
  PRODUCT_REQUEST_APPROVE: 'product_request_approve',
  PRODUCT_REQUEST_REJECT: 'product_request_reject',
  STOCK_MOVEMENTS: 'movements',
  STOCK_CREATE_MOVEMENT: 'create_movement',
  STOCK_INVOICES: 'invoices',
  STOCK_IMPORT_INVOICE: 'import_invoice',
  STOCK_INCOMING_CANCEL: 'incoming_cancel',
  STOCK_INCOMING_LAUNCH: 'incoming_launch',
  STOCK_RETURNS_VIEW: 'returns_view',
  STOCK_RETURNS_CREATE: 'returns_create',
  STOCK_RETURNS_UPDATE: 'returns_update',
  STOCK_RETURNS_APPROVE: 'returns_approve',
  STOCK_CREDITS_VIEW: 'credits_view',
  STOCK_CREDITS_CREATE: 'credits_create',
  STOCK_CREDITS_APPROVE: 'credits_approve',
  STOCK_CREDITS_USE: 'credits_use',
  STOCK_AUDIT_VIEW: 'audit_view',
  STOCK_AUDIT_CREATE: 'audit_create',
  STOCK_AUDIT_EXECUTE: 'audit_execute',
  STOCK_AUDIT_APPLY: 'audit_apply',
  STOCK_AUDIT_CANCEL: 'audit_cancel',
  STOCK_AUDIT_REOPEN: 'audit_reopen',
  STOCK_AUDITS_EDIT_RESPONSIBLE: 'audits_edit_responsible',
  STOCK_ADJUSTMENT_VIEW: 'adjustment_view',
  STOCK_ADJUSTMENT_CREATE: 'adjustment_create',
  STOCK_ADJUSTMENT_APPROVE: 'adjustment_approve',
  STOCK_ADJUSTMENT_REJECT: 'adjustment_reject',
  SALES_PDV_VIEW: 'pdv_view',
  SALES_RELATION_VIEW: 'relation_view',
  SALES_PRESALE: 'presale',
  SALES_PRESALE_LIST_VIEW: 'presale_list_view',
  SALES_ONLINE_VIEW: 'online_view',
  SALES_ONLINE_UPDATE: 'online_update',
  SALES_ONLINE_DELETE: 'online_delete',
  SALES_NFE_VIEW: 'nfe_view',
  SALES_NFE_CREATE: 'nfe_create',
  SALES_NFE_UPDATE: 'nfe_update',
  SALES_SPECIAL_TABLES_VIEW: 'special_tables_view',
  SALES_SPECIAL_TABLES_MANAGE: 'special_tables_manage',
  SALES_FINALIZE: 'finalize',
  SALES_CANCEL: 'cancel',
  SALES_CASH_REGISTER_RECONCILIATION: 'cash_register_reconciliation',
  SALES_SELLER_ASSISTANT: 'seller_assistant',
  SALES_TV_DISPLAY: 'tv_display',
  SALES_RETURN_NFE: 'return_nfe',
  SALES_DATA_READ: 'data_read',
  PEOPLE_CUSTOMERS: 'customers',
  PEOPLE_CUSTOMERS_BONUS_MANUAL: 'customers_bonus_manual',
  PEOPLE_SUPPLIERS: 'suppliers',
  PEOPLE_USERS: 'users',
  PEOPLE_ACCESS_GROUPS: 'access_groups',
  FINANCIAL_ACCOUNTS: 'accounts',
  FINANCIAL_CATEGORIES: 'categories',
  FINANCIAL_COST_CENTERS: 'cost_centers',
  FINANCIAL_PAYMENT_METHODS: 'payment_methods',
  FINANCIAL_RECEIPT_METHODS: 'receipt_methods',
  FINANCIAL_PAYABLES: 'payables',
  /** Legado: concede todas as ações de contas a receber */
  FINANCIAL_RECEIVABLES: 'receivables',
  FINANCIAL_RECEIVABLES_VIEW: 'receivables_view',
  FINANCIAL_RECEIVABLES_CREATE: 'receivables_create',
  FINANCIAL_RECEIVABLES_UPDATE: 'receivables_update',
  FINANCIAL_RECEIVABLES_DELETE: 'receivables_delete',
  FINANCIAL_RECEIVABLES_MARK_PAID: 'receivables_mark_paid',
  FINANCIAL_RECEIVABLES_BOLETO: 'receivables_boleto',
  FINANCIAL_CASH_FLOW: 'cash_flow',
  FINANCIAL_CARD_RECONCILIATION: 'card_reconciliation',
  FINANCIAL_REPORTS: 'financial_reports',
  FINANCIAL_DRE: 'dre_view',
  FINANCIAL_DFC: 'dfc_view',
  FINANCIAL_BALANCE_SHEET: 'balance_sheet_view',
  FINANCIAL_PURCHASE_APPROVAL: 'purchase_approval',
  FINANCIAL_BOLETOS_VIEW: 'boletos_view',
  FINANCIAL_BOLETOS_DASHBOARD: 'boletos_dashboard',
  SETTINGS_CERTIFICATES: 'certificates',
  DIGITAL_CERTIFICATE_MANAGE: 'manage',
  DOCUMENTS_DASHBOARD: 'dashboard',
  DOCUMENTS_COMPANY_VIEW: 'company_view',
  DOCUMENTS_COMPANY_EDIT: 'company_edit',
  DOCUMENTS_COMPANY_UPLOAD: 'company_upload',
  DOCUMENTS_USER_VIEW: 'user_view',
  DOCUMENTS_CATEGORIES_VIEW: 'categories_view',
  // Ações específicas de Orçamentos
  QUOTES_APPROVE: 'approve',
  QUOTES_CANCEL: 'cancel',
  QUOTES_OPEN: 'open',
  QUOTES_RESERVE: 'reserve',
  QUOTES_CONVERT: 'convert',
  QUOTES_REVERT_TO_DRAFT: 'revert_to_draft',
  // Ações específicas de Ponto Eletrônico
  ATTENDANCE_VIEW: 'view',
  ATTENDANCE_CREATE: 'create',
  ATTENDANCE_REPORTS: 'reports',
  ATTENDANCE_ACCOUNTING: 'accounting',
  ATTENDANCE_LOG: 'log_view',
  ATTENDANCE_LOG_EDIT: 'log_edit',
  // Ações específicas de Prospecção
  PROSPECTING_VIEW: 'view',
  PROSPECTING_CREATE: 'create',
  PROSPECTING_UPDATE: 'update',
  PROSPECTING_LEADS: 'leads',
  PROSPECTING_PROPOSALS: 'proposals',
  PROSPECTING_REDISTRIBUTE: 'redistribute',
  PROSPECTING_WALLET: 'wallet',
  // Ações específicas de Compras
  PURCHASES_DASHBOARD: 'dashboard',
  PURCHASES_FOLLOW_UP: 'follow_up',
  PURCHASES_INTELLIGENCE: 'intelligence',
  // Ações específicas de Mensagens
  MESSAGES_SEND: 'send',
  // Ações específicas de Relatórios (hub /erp/relatorios)
  REPORTS_RECEIVABLES: 'receivables',
  REPORTS_STOCK: 'stock',
  REPORTS_SALES: 'sales',
  PATIENTS_DELETE_PATIENT: 'delete_patient',
  PATIENTS_ARCHIVE: 'archive',
  PATIENTS_VITALS: 'vitals',
  PATIENTS_VITALS_WEIGHT: 'vitals_weight',
  PATIENTS_VITALS_HEIGHT: 'vitals_height',
  PATIENTS_VITALS_RECORD: 'vitals_record',
  PATIENTS_VITALS_EDIT: 'vitals_edit',
  PATIENTS_VITALS_SHORTCUT: 'vitals_shortcut',
  PATIENTS_MEDICATIONS: 'medications',
  PATIENTS_MEDICATIONS_PRESCRIBE: 'medications_prescribe',
  PATIENTS_MEDICATIONS_ADMINISTER: 'medications_administer',
  PATIENTS_CONTACTS: 'contacts',
  PATIENTS_CONTACTS_EDIT: 'contacts_edit',
  PATIENTS_FINANCIAL: 'financial',
  PATIENTS_EVOLUTIONS: 'evolutions',
  PATIENTS_EVOLUTIONS_PRINT: 'evolutions_print',
  PATIENTS_EVOLUTION_ROLES: 'evolution_roles',
  PATIENTS_DOCUMENTS: 'documents',
  PATIENTS_THERAPY: 'therapy',
  PATIENTS_THERAPY_ACTIVITIES: 'therapy_activities',
  PATIENTS_THERAPY_GOALS: 'therapy_goals',
  PATIENTS_NUTRITION: 'nutrition',
  PATIENTS_NUTRITION_PRESCRIPTIONS: 'nutrition_prescriptions',
  PATIENTS_NUTRITION_PRESCRIPTIONS_CREATE: 'nutrition_prescriptions_create',
  PATIENTS_NUTRITION_RECORD: 'nutrition_record',
  PATIENTS_NUTRITION_WATER: 'nutrition_water',
  PATIENTS_CHART_PRINT: 'chart_print',
  PATIENTS_MANAGE_ACCESS: 'manage_access',
  PATIENTS_BYPASS_ACCESS: 'bypass_access',
  PATIENTS_SHIFT_REQUIRED: 'shift_required',
  PATIENTS_DASHBOARD: 'dashboard',
  PATIENTS_NOTES: 'notes',
  PATIENTS_NOTES_RECORD: 'notes_record',
  DUTY_ROSTERS_GENERATE: 'generate',
  DUTY_ROSTERS_EDIT: 'edit',
  DUTY_ROSTERS_SAVE: 'save',
  PATIENTS_EDIT_CHART: 'edit_chart'
}

/**
 * Estrutura de permissões por módulo (para interface de gerenciamento)
 */
export const MODULE_ACTIONS = {
  [MODULES.ERP]: [
    { key: ACTIONS.VIEW, label: 'Acessar ERP' },
    {
      key: ACTIONS.ERP_OPERATIONAL_ASSISTANT,
      label: 'Assistente Operacional (mapa do ERP)',
      group: 'Assistentes IA'
    }
  ],
  [MODULES.DASHBOARD]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Dashboard' }
  ],
  [MODULES.COCKPIT]: [
    { key: ACTIONS.VIEW, label: 'Acessar Cockpit de Performance' }
  ],
  [MODULES.PRODUCTS]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Produtos' },
    { key: ACTIONS.CREATE, label: 'Criar Produto' },
    { key: ACTIONS.UPDATE, label: 'Editar Produto' },
    { key: ACTIONS.DELETE, label: 'Deletar Produto' },
    { key: ACTIONS.PRODUCTS_GROUPS, label: 'Gerenciar Grupos' },
    { key: ACTIONS.PRODUCTS_BRANDS, label: 'Gerenciar Marcas' },
    { key: ACTIONS.PRODUCTS_UNITS, label: 'Gerenciar Unidades' },
    { key: ACTIONS.PRODUCTS_IMAGES, label: 'Adicionar/Remover Fotos' },
    { key: ACTIONS.PRODUCTS_EDIT_DESCRIPTION, label: 'Editar descrição do produto', group: 'Ficha do produto' },
    { key: ACTIONS.PRODUCTS_EDIT_BRAND, label: 'Editar marca', group: 'Ficha do produto' },
    { key: ACTIONS.PRODUCTS_EDIT_GROUP, label: 'Editar grupo', group: 'Ficha do produto' },
    { key: ACTIONS.PRODUCTS_EDIT_CUBAGE, label: 'Editar cubagem e frete', group: 'Ficha do produto' },
    { key: ACTIONS.PRODUCTS_HIDE_COST, label: 'Ocultar custo do produto', group: 'Ficha do produto' },
    { key: ACTIONS.PRODUCTS_GRIDS, label: 'Gerenciar Grades de Produtos' },
    { key: ACTIONS.PRODUCT_REQUEST_VIEW, label: 'Visualizar Solicitações de Criação', group: 'Solicitação de Criação' },
    { key: ACTIONS.PRODUCT_REQUEST_CREATE, label: 'Criar/Editar Solicitação de Produto', group: 'Solicitação de Criação' },
    { key: ACTIONS.PRODUCT_REQUEST_APPROVE, label: 'Aprovar Solicitação de Produto', group: 'Solicitação de Criação' },
    { key: ACTIONS.PRODUCT_REQUEST_REJECT, label: 'Rejeitar Solicitação de Produto', group: 'Solicitação de Criação' }
  ],
  [MODULES.STOCK]: [
    // Sub-módulo: Estoque Geral
    { key: ACTIONS.VIEW, label: 'Visualizar Estoque', group: 'Estoque Geral' },
    
    // Sub-módulo: Entrada de Mercadoria
    { key: ACTIONS.STOCK_INVOICES, label: 'Visualizar Entrada de Notas Fiscais', group: 'Entrada de Mercadoria' },
    { key: ACTIONS.STOCK_IMPORT_INVOICE, label: 'Importar e Processar Nota Fiscal', group: 'Entrada de Mercadoria' },
    { key: ACTIONS.STOCK_INCOMING_CANCEL, label: 'Cancelar Entrada / XML em Validação', group: 'Entrada de Mercadoria' },
    { key: ACTIONS.STOCK_INCOMING_LAUNCH, label: 'Lançar Estoque a partir da NF', group: 'Entrada de Mercadoria' },
    
    // Sub-módulo: Movimentações
    { key: ACTIONS.STOCK_MOVEMENTS, label: 'Visualizar Movimentações', group: 'Movimentações' },
    { key: ACTIONS.STOCK_CREATE_MOVEMENT, label: 'Criar Movimentação Manual', group: 'Movimentações' },
    
    // Sub-módulo: Trocas e Devoluções
    { key: ACTIONS.STOCK_RETURNS_VIEW, label: 'Visualizar Trocas/Devoluções', group: 'Trocas e Devoluções' },
    { key: ACTIONS.STOCK_RETURNS_CREATE, label: 'Criar Troca/Devolução', group: 'Trocas e Devoluções' },
    { key: ACTIONS.STOCK_RETURNS_UPDATE, label: 'Editar Troca/Devolução', group: 'Trocas e Devoluções' },
    { key: ACTIONS.STOCK_RETURNS_APPROVE, label: 'Aprovar/Rejeitar Devolução', group: 'Trocas e Devoluções' },
    
    // Sub-módulo: Créditos de Clientes
    { key: ACTIONS.STOCK_CREDITS_VIEW, label: 'Visualizar Créditos de Clientes', group: 'Créditos de Clientes' },
    { key: ACTIONS.STOCK_CREDITS_CREATE, label: 'Criar Crédito', group: 'Créditos de Clientes' },
    { key: ACTIONS.STOCK_CREDITS_APPROVE, label: 'Aprovar/Cancelar Crédito', group: 'Créditos de Clientes' },
    { key: ACTIONS.STOCK_CREDITS_USE, label: 'Usar Crédito em Compras', group: 'Créditos de Clientes' },
    
    // Sub-módulo: Auditoria de Estoque
    { key: ACTIONS.STOCK_AUDIT_VIEW, label: 'Visualizar Auditorias', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDIT_CREATE, label: 'Criar Auditoria Manual', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDIT_EXECUTE, label: 'Executar Auditoria', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDIT_APPLY, label: 'Aplicar Alterações ao Estoque', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDIT_CANCEL, label: 'Cancelar Auditoria', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDIT_REOPEN, label: 'Reabrir Auditoria Concluída', group: 'Auditoria de Estoque' },
    { key: ACTIONS.STOCK_AUDITS_EDIT_RESPONSIBLE, label: 'Editar Responsável da Auditoria', group: 'Auditoria de Estoque' },
    
    // Sub-módulo: Ajuste de Estoque Físico/Digital
    { key: ACTIONS.STOCK_ADJUSTMENT_VIEW, label: 'Visualizar Ajustes de Estoque', group: 'Ajuste de Estoque Físico/Digital' },
    { key: ACTIONS.STOCK_ADJUSTMENT_CREATE, label: 'Criar/Editar Ajuste de Estoque', group: 'Ajuste de Estoque Físico/Digital' },
    { key: ACTIONS.STOCK_ADJUSTMENT_APPROVE, label: 'Aprovar Ajuste de Estoque', group: 'Ajuste de Estoque Físico/Digital' },
    { key: ACTIONS.STOCK_ADJUSTMENT_REJECT, label: 'Rejeitar Ajuste de Estoque', group: 'Ajuste de Estoque Físico/Digital' }
  ],
  [MODULES.SALES]: [
    { key: ACTIONS.SALES_PDV_VIEW, label: 'Visualizar PDV (Vendas)', group: 'PDV (Vendas)' },
    { key: ACTIONS.CREATE, label: 'Criar Venda', group: 'PDV (Vendas)' },
    { key: ACTIONS.UPDATE, label: 'Editar Venda', group: 'PDV (Vendas)' },
    { key: ACTIONS.DELETE, label: 'Deletar Venda', group: 'PDV (Vendas)' },
    { key: ACTIONS.SALES_FINALIZE, label: 'Finalizar Vendas', group: 'PDV (Vendas)' },
    { key: ACTIONS.SALES_CANCEL, label: 'Cancelar Vendas', group: 'PDV (Vendas)' },
    { key: ACTIONS.SALES_RELATION_VIEW, label: 'Visualizar Relação de Vendas', group: 'Relação de Vendas' },
    { key: ACTIONS.SALES_PRESALE, label: 'Acessar Pré-Venda', group: 'Pré-Venda' },
    { key: ACTIONS.SALES_PRESALE_LIST_VIEW, label: 'Visualizar Relação de Pré-Venda', group: 'Pré-Venda' },
    { key: ACTIONS.SALES_ONLINE_VIEW, label: 'Visualizar Vendas Online', group: 'Vendas Online' },
    { key: ACTIONS.SALES_ONLINE_UPDATE, label: 'Editar Vendas Online', group: 'Vendas Online' },
    { key: ACTIONS.SALES_ONLINE_DELETE, label: 'Cancelar Vendas Online', group: 'Vendas Online' },
    { key: ACTIONS.SALES_NFE_VIEW, label: 'Visualizar NF-e', group: 'NF-e' },
    { key: ACTIONS.SALES_NFE_CREATE, label: 'Criar/Emitir NF-e', group: 'NF-e' },
    { key: ACTIONS.SALES_NFE_UPDATE, label: 'Editar Rascunho NF-e', group: 'NF-e' },
    { key: ACTIONS.SALES_SPECIAL_TABLES_VIEW, label: 'Visualizar Tabelas Especiais', group: 'Tabelas Especiais' },
    { key: ACTIONS.SALES_SPECIAL_TABLES_MANAGE, label: 'Criar/Editar/Excluir Tabelas', group: 'Tabelas Especiais' },
    { key: ACTIONS.SALES_CASH_REGISTER_RECONCILIATION, label: 'Conferência de Caixa', group: 'Conferência de Caixa' },
    { key: ACTIONS.SALES_SELLER_ASSISTANT, label: 'Assistente de Vendas (busca de produtos)', group: 'Assistentes IA' },
    { key: ACTIONS.SALES_TV_DISPLAY, label: 'Vitrine TV (telão da loja)', group: 'Vitrine TV' },
    { key: ACTIONS.SALES_RETURN_NFE, label: 'Emitir NF de devolução', group: 'Relação de Vendas' }
  ],
  [MODULES.QUOTES]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Orçamentos' },
    { key: ACTIONS.CREATE, label: 'Criar Orçamento' },
    { key: ACTIONS.UPDATE, label: 'Editar Orçamento' },
    { key: ACTIONS.DELETE, label: 'Deletar Orçamento' },
    { key: ACTIONS.QUOTES_APPROVE, label: 'Aprovar Orçamento' },
    { key: ACTIONS.QUOTES_REVERT_TO_DRAFT, label: 'Voltar para Rascunho' },
    { key: ACTIONS.QUOTES_CANCEL, label: 'Cancelar Orçamento' },
    { key: ACTIONS.QUOTES_OPEN, label: 'Enviar ao Cliente' },
    { key: ACTIONS.QUOTES_RESERVE, label: 'Solicitar Reserva de Estoque' },
    { key: ACTIONS.QUOTES_CONVERT, label: 'Converter em Venda' }
  ],
  [MODULES.PEOPLE]: [
    { key: ACTIONS.PEOPLE_CUSTOMERS, label: 'Gerenciar Clientes' },
    { key: ACTIONS.PEOPLE_CUSTOMERS_BONUS_MANUAL, label: 'Adicionar/diminuir bônus manual do cliente', group: 'Clientes' },
    { key: ACTIONS.PEOPLE_SUPPLIERS, label: 'Gerenciar Fornecedores' },
    { key: ACTIONS.PEOPLE_USERS, label: 'Gerenciar Usuários' },
    { key: ACTIONS.PEOPLE_ACCESS_GROUPS, label: 'Gerenciar Grupos de Acesso' }
  ],
  [MODULES.FINANCIAL]: [
    { key: ACTIONS.FINANCIAL_ACCOUNTS, label: 'Gerenciar Contas' },
    { key: ACTIONS.FINANCIAL_CATEGORIES, label: 'Gerenciar Categorias' },
    { key: ACTIONS.FINANCIAL_COST_CENTERS, label: 'Gerenciar Centros de Custo' },
    { key: ACTIONS.FINANCIAL_PAYMENT_METHODS, label: 'Gerenciar Métodos de Pagamento' },
    { key: ACTIONS.FINANCIAL_RECEIPT_METHODS, label: 'Gerenciar Formas de Recebimento' },
    { key: ACTIONS.FINANCIAL_PAYABLES, label: 'Gerenciar Contas a Pagar' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_VIEW, label: 'Visualizar Contas a Receber', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_CREATE, label: 'Criar Conta a Receber', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_UPDATE, label: 'Editar Conta a Receber', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_DELETE, label: 'Excluir Conta a Receber', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_MARK_PAID, label: 'Dar Baixa (Marcar como Pago)', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_RECEIVABLES_BOLETO, label: 'Gerar e Sincronizar Boleto', group: 'Contas a Receber' },
    { key: ACTIONS.FINANCIAL_DRE, label: 'Visualizar DRE', group: 'Relatórios Financeiros' },
    { key: ACTIONS.FINANCIAL_DFC, label: 'Visualizar DFC', group: 'Relatórios Financeiros' },
    { key: ACTIONS.FINANCIAL_BALANCE_SHEET, label: 'Visualizar Balanço Contábil', group: 'Relatórios Financeiros' },
    { key: ACTIONS.FINANCIAL_CASH_FLOW, label: 'Visualizar Extrato de Caixa' },
    { key: ACTIONS.FINANCIAL_CARD_RECONCILIATION, label: 'Conciliação de Cartões' },
    { key: ACTIONS.FINANCIAL_PURCHASE_APPROVAL, label: 'Aprovação Financeira de Compras', group: 'Compras' },
    { key: ACTIONS.FINANCIAL_BOLETOS_DASHBOARD, label: 'Dashboard de Boletos', group: 'Boletos' },
    { key: ACTIONS.FINANCIAL_BOLETOS_VIEW, label: 'Listagem de Boletos', group: 'Boletos' }
  ],
  [MODULES.SETTINGS]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Configurações' },
    { key: ACTIONS.UPDATE, label: 'Editar Configurações' }
  ],
  [MODULES.DIGITAL_CERTIFICATE]: [
    { key: ACTIONS.DIGITAL_CERTIFICATE_MANAGE, label: 'Gerenciar certificado digital' }
  ],
  [MODULES.DOCUMENTS]: [
    { key: ACTIONS.DOCUMENTS_DASHBOARD, label: 'Dashboard' },
    { key: ACTIONS.DOCUMENTS_COMPANY_VIEW, label: 'Documentos da Empresa' },
    { key: ACTIONS.DOCUMENTS_USER_VIEW, label: 'Documentos dos Usuários' },
    { key: ACTIONS.ATTENDANCE_ACCOUNTING, label: 'Extrato de Ponto', module: MODULES.ATTENDANCE },
    { key: ACTIONS.ATTENDANCE_LOG, label: 'Espelho de Ponto', module: MODULES.ATTENDANCE },
    { key: ACTIONS.DOCUMENTS_CATEGORIES_VIEW, label: 'Categorias' },
    { key: ACTIONS.ATTENDANCE_LOG_EDIT, label: 'Editar horários', module: MODULES.ATTENDANCE },
    { key: ACTIONS.DOCUMENTS_COMPANY_EDIT, label: 'Editar Documentos da Empresa' },
    { key: ACTIONS.DOCUMENTS_COMPANY_UPLOAD, label: 'Upload Documentos da Empresa' },
    { key: ACTIONS.VIEW, label: 'Visualizar Meus Documentos', group: 'Meus Documentos' },
    { key: ACTIONS.CREATE, label: 'Adicionar Meus Documentos', group: 'Meus Documentos' },
    { key: ACTIONS.UPDATE, label: 'Editar Meus Documentos', group: 'Meus Documentos' },
    { key: ACTIONS.DELETE, label: 'Excluir Meus Documentos', group: 'Meus Documentos' }
  ],
  [MODULES.ATTENDANCE]: [
    { key: ACTIONS.ATTENDANCE_VIEW, label: 'Ponto Eletrônico' },
    { key: ACTIONS.ATTENDANCE_CREATE, label: 'Registrar Ponto' },
    { key: ACTIONS.ATTENDANCE_REPORTS, label: 'Visualizar Relatórios' }
  ],
  [MODULES.PROSPECTING]: [
    { key: ACTIONS.PROSPECTING_VIEW, label: 'Visualizar Prospecção', group: 'Geral' },
    { key: ACTIONS.PROSPECTING_CREATE, label: 'Criar Lead/Proposta', group: 'Geral' },
    { key: ACTIONS.PROSPECTING_UPDATE, label: 'Editar/Cancelar Lead/Proposta', group: 'Geral' },
    { key: ACTIONS.PROSPECTING_LEADS, label: 'Gerenciar Leads', group: 'Leads' },
    { key: ACTIONS.PROSPECTING_PROPOSALS, label: 'Gerenciar Propostas', group: 'Propostas' },
    { key: ACTIONS.PROSPECTING_REDISTRIBUTE, label: 'Redistribuir carteira', group: 'Geral' },
    { key: ACTIONS.PROSPECTING_WALLET, label: 'Ter carteira de clientes', group: 'Geral' }
  ],
  [MODULES.PURCHASES]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Compras', group: 'Geral' },
    { key: ACTIONS.CREATE, label: 'Criar Requisição de Compra', group: 'Geral' },
    { key: ACTIONS.PURCHASES_DASHBOARD, label: 'Acessar Painel de Compras', group: 'Painel de Compras' },
    { key: ACTIONS.PURCHASES_FOLLOW_UP, label: 'Acessar Acompanhamento', group: 'Acompanhamento' },
    { key: ACTIONS.PURCHASES_INTELLIGENCE, label: 'Acessar Compra Inteligente', group: 'Compra Inteligente' }
  ],
  [MODULES.MESSAGES]: [
    { key: ACTIONS.VIEW, label: 'Visualizar Mensagens' },
    { key: ACTIONS.CREATE, label: 'Criar Conversa' },
    { key: ACTIONS.UPDATE, label: 'Editar Conversa' },
    { key: ACTIONS.DELETE, label: 'Excluir Conversa/Mensagem' },
    { key: ACTIONS.MESSAGES_SEND, label: 'Enviar Mensagens' }
  ],
  [MODULES.REPORTS]: [
    { key: ACTIONS.VIEW, label: 'Acessar hub de Relatórios', group: 'Geral' },
    { key: ACTIONS.REPORTS_RECEIVABLES, label: 'Relatório Contas a Receber', group: 'Relatórios' },
    { key: ACTIONS.REPORTS_STOCK, label: 'Relatório de Estoque', group: 'Relatórios' },
    { key: ACTIONS.REPORTS_SALES, label: 'Relatório de Vendas', group: 'Relatórios' }
  ],
  [MODULES.PATIENTS]: [
    { key: ACTIONS.VIEW, label: 'Ver pacientes', group: 'Geral' },
    { key: ACTIONS.CREATE, label: 'Admitir paciente', group: 'Geral' },
    { key: ACTIONS.UPDATE, label: 'Editar prontuário', group: 'Geral' },
    { key: ACTIONS.DELETE, label: 'Excluir alergia, alerta ou foto', group: 'Geral' },
    { key: ACTIONS.PATIENTS_DELETE_PATIENT, label: 'Excluir paciente', group: 'Geral' },
    { key: ACTIONS.PATIENTS_ARCHIVE, label: 'Arquivar paciente', group: 'Geral' },
    { key: ACTIONS.PATIENTS_CHART_PRINT, label: 'Imprimir/Download do prontuário', group: 'Geral' },
    { key: ACTIONS.PATIENTS_MANAGE_ACCESS, label: 'Modificar acesso do prontuário', group: 'Geral' },
    { key: ACTIONS.PATIENTS_BYPASS_ACCESS, label: 'Ignorar controle de acesso', group: 'Geral' },
    { key: ACTIONS.PATIENTS_SHIFT_REQUIRED, label: 'Exigir plantão para registrar', group: 'Geral' },
    { key: ACTIONS.PATIENTS_DASHBOARD, label: 'Acessar painel clínico', group: 'Geral' },
    { key: ACTIONS.PATIENTS_VITALS, label: 'Ver a aba', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_VITALS_WEIGHT, label: 'Registrar peso', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_VITALS_HEIGHT, label: 'Registrar altura', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_VITALS_RECORD, label: 'Registrar novos sinais', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_VITALS_EDIT, label: 'Corrigir aferições', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_VITALS_SHORTCUT, label: 'Ver atalho de sinais', group: 'Tab Sinais' },
    { key: ACTIONS.PATIENTS_MEDICATIONS, label: 'Ver a aba', group: 'Tab Medicamentos' },
    { key: ACTIONS.PATIENTS_MEDICATIONS_PRESCRIBE, label: 'Prescrever medicamento', group: 'Tab Medicamentos' },
    { key: ACTIONS.PATIENTS_MEDICATIONS_ADMINISTER, label: 'Administrar', group: 'Tab Medicamentos' },
    { key: ACTIONS.PATIENTS_NUTRITION, label: 'Ver a aba', group: 'Tab Alimentação' },
    { key: ACTIONS.PATIENTS_NUTRITION_PRESCRIPTIONS, label: 'Ver prescrições nutricionais', group: 'Tab Alimentação' },
    { key: ACTIONS.PATIENTS_NUTRITION_PRESCRIPTIONS_CREATE, label: 'Criar prescrições nutricionais', group: 'Tab Alimentação' },
    { key: ACTIONS.PATIENTS_NUTRITION_RECORD, label: 'Registrar refeição', group: 'Tab Alimentação' },
    { key: ACTIONS.PATIENTS_NUTRITION_WATER, label: 'Ver atalho de água', group: 'Tab Alimentação' },
    { key: ACTIONS.PATIENTS_CONTACTS, label: 'Ver a aba', group: 'Tab Contatos' },
    { key: ACTIONS.PATIENTS_CONTACTS_EDIT, label: 'Editar contatos na página', group: 'Tab Contatos' },
    { key: ACTIONS.PATIENTS_FINANCIAL, label: 'Ver a aba', group: 'Tab Financeiro' },
    { key: ACTIONS.PATIENTS_EVOLUTIONS, label: 'Ver a aba', group: 'Tab Evoluções' },
    { key: ACTIONS.PATIENTS_EVOLUTION_ROLES, label: 'Criar áreas de atuação', group: 'Tab Evoluções' },
    { key: ACTIONS.PATIENTS_EVOLUTIONS_PRINT, label: 'Imprimir/Download da evolução', group: 'Tab Evoluções' },
    { key: ACTIONS.PATIENTS_NOTES, label: 'Ver a aba', group: 'Tab Diário' },
    { key: ACTIONS.PATIENTS_NOTES_RECORD, label: 'Registrar nota rápida', group: 'Tab Diário' },
    { key: ACTIONS.PATIENTS_THERAPY, label: 'Ver a aba', group: 'Tab Reabilitação' },
    { key: ACTIONS.PATIENTS_THERAPY_ACTIVITIES, label: 'Criar nova atividade', group: 'Tab Reabilitação' },
    { key: ACTIONS.PATIENTS_THERAPY_GOALS, label: 'Criar nova meta', group: 'Tab Reabilitação' },
    { key: ACTIONS.PATIENTS_DOCUMENTS, label: 'Ver a aba', group: 'Tab Documentação' },
    { key: ACTIONS.PATIENTS_EDIT_CHART, label: 'Editar dados do prontuário', group: 'Geral' }
  ],
  [MODULES.DUTY_ROSTERS]: [
    { key: ACTIONS.VIEW, label: 'Plantões' },
    { key: ACTIONS.DUTY_ROSTERS_GENERATE, label: 'Gerar plantões' },
    { key: ACTIONS.DUTY_ROSTERS_EDIT, label: 'Editar escala' },
    { key: ACTIONS.DUTY_ROSTERS_SAVE, label: 'Salvar escalas' }
  ],
  [MODULES.MY_SHIFTS]: [
    { key: ACTIONS.VIEW, label: 'Meus plantões' }
  ]
}

/**
 * Labels dos módulos para exibição
 */
export const MODULE_LABELS = {
  [MODULES.ERP]: 'ERP',
  [MODULES.DASHBOARD]: 'Dashboard',
  [MODULES.COCKPIT]: 'Cockpit',
  [MODULES.PRODUCTS]: 'Produtos',
  [MODULES.STOCK]: 'Estoque',
  [MODULES.SALES]: 'Vendas',
  [MODULES.QUOTES]: 'Orçamentos',
  [MODULES.PEOPLE]: 'Pessoas',
  [MODULES.FINANCIAL]: 'Financeiro',
  [MODULES.SETTINGS]: 'Configurações',
  [MODULES.DIGITAL_CERTIFICATE]: 'Certificado digital',
  [MODULES.DOCUMENTS]: 'Documentos',
  [MODULES.ATTENDANCE]: 'Ponto Eletrônico',
  [MODULES.PROSPECTING]: 'Prospecção',
  [MODULES.PURCHASES]: 'Compras',
  [MODULES.MESSAGES]: 'Mensagens',
  [MODULES.REPORTS]: 'Relatórios',
  [MODULES.PATIENTS]: 'Pacientes',
  [MODULES.DUTY_ROSTERS]: 'Plantões',
  [MODULES.MY_SHIFTS]: 'Meus plantões'
}

/**
 * Obtém todas as ações de um módulo
 */
export function actionStorageModule(action, displayModule) {
  return action.module || displayModule
}

export function getModuleActions(module) {
  return MODULE_ACTIONS[module] || []
}

/**
 * Obtém label de um módulo
 */
export function getModuleLabel(module) {
  return MODULE_LABELS[module] || module
}

/**
 * Acesso a um relatório do hub /erp/relatorios.
 * Prioriza permissões do módulo reports; mantém fallback nos módulos de domínio.
 */
export function canAccessErpReport(hasPermissionFn, reportAction) {
  if (typeof hasPermissionFn !== 'function' || !reportAction) return false
  if (hasPermissionFn(MODULES.REPORTS, reportAction)) return true

  switch (reportAction) {
    case ACTIONS.REPORTS_RECEIVABLES:
      return hasPermissionFn(MODULES.FINANCIAL, ACTIONS.FINANCIAL_RECEIVABLES_VIEW)
    case ACTIONS.REPORTS_STOCK:
      return (
        hasPermissionFn(MODULES.PRODUCTS, ACTIONS.VIEW) ||
        hasPermissionFn(MODULES.STOCK, ACTIONS.VIEW) ||
        hasPermissionFn(MODULES.STOCK, ACTIONS.STOCK_MOVEMENTS)
      )
    case ACTIONS.REPORTS_SALES:
      return hasPermissionFn(MODULES.SALES, ACTIONS.SALES_RELATION_VIEW)
    default:
      return false
  }
}

/** Hub Relatórios: VIEW do módulo ou qualquer relatório liberado. */
export function canAccessReportsHub(hasPermissionFn) {
  if (typeof hasPermissionFn !== 'function') return false
  if (hasPermissionFn(MODULES.REPORTS, ACTIONS.VIEW)) return true
  return (
    canAccessErpReport(hasPermissionFn, ACTIONS.REPORTS_RECEIVABLES) ||
    canAccessErpReport(hasPermissionFn, ACTIONS.REPORTS_STOCK) ||
    canAccessErpReport(hasPermissionFn, ACTIONS.REPORTS_SALES)
  )
}

export const FINANCIAL_REPORT_GRANULAR_ACTIONS = [
  ACTIONS.FINANCIAL_DRE,
  ACTIONS.FINANCIAL_DFC,
  ACTIONS.FINANCIAL_BALANCE_SHEET
]

export function resolveFinancialReportPermission(permissions, action) {
  const financial = permissions?.[MODULES.FINANCIAL]
  if (!financial) {
    return false
  }
  if (financial[action] === true) {
    return true
  }
  if (financial[ACTIONS.FINANCIAL_REPORTS] === true && FINANCIAL_REPORT_GRANULAR_ACTIONS.includes(action)) {
    return true
  }
  return false
}

export const RECEIVABLE_GRANULAR_ACTIONS = [
  ACTIONS.FINANCIAL_RECEIVABLES_VIEW,
  ACTIONS.FINANCIAL_RECEIVABLES_CREATE,
  ACTIONS.FINANCIAL_RECEIVABLES_UPDATE,
  ACTIONS.FINANCIAL_RECEIVABLES_DELETE,
  ACTIONS.FINANCIAL_RECEIVABLES_MARK_PAID,
  ACTIONS.FINANCIAL_RECEIVABLES_BOLETO
]

/**
 * Verifica permissão de contas a receber (inclui legado "receivables" = acesso total)
 */
export function resolveFinancialReceivablePermission(permissions, action) {
  const financial = permissions?.[MODULES.FINANCIAL]
  if (!financial) {
    return false
  }
  if (financial[action] === true) {
    return true
  }
  if (financial[ACTIONS.FINANCIAL_RECEIVABLES] === true && RECEIVABLE_GRANULAR_ACTIONS.includes(action)) {
    return true
  }
  return false
}

const SALES_PAGE_VIEW_ACTIONS = [
  ACTIONS.SALES_PDV_VIEW,
  ACTIONS.SALES_RELATION_VIEW,
  ACTIONS.SALES_PRESALE_LIST_VIEW,
  ACTIONS.SALES_ONLINE_VIEW,
  ACTIONS.SALES_NFE_VIEW,
  ACTIONS.SALES_SPECIAL_TABLES_VIEW,
  ACTIONS.SALES_TV_DISPLAY,
]

export const SALES_GRANULAR_ACTIONS = [
  ...SALES_PAGE_VIEW_ACTIONS,
  ACTIONS.SALES_PRESALE,
  ACTIONS.SALES_ONLINE_UPDATE,
  ACTIONS.SALES_ONLINE_DELETE,
  ACTIONS.SALES_NFE_CREATE,
  ACTIONS.SALES_NFE_UPDATE,
  ACTIONS.SALES_SPECIAL_TABLES_MANAGE,
  ACTIONS.SALES_FINALIZE,
  ACTIONS.SALES_CANCEL,
  ACTIONS.SALES_CASH_REGISTER_RECONCILIATION,
  ACTIONS.SALES_DATA_READ,
  ACTIONS.SALES_SELLER_ASSISTANT,
  ACTIONS.SALES_TV_DISPLAY,
  ACTIONS.SALES_RETURN_NFE
]

/**
 * Monta objeto completo para o editor: cada ação do MODULE_ACTIONS vira boolean explícito.
 */
export function buildPermissionsForEditor(storedPermissions = {}) {
  const stored = normalizeSalesPermissions(storedPermissions)
  const editor = {}

  Object.values(MODULES).forEach((module) => {
    if (!editor[module]) editor[module] = {}
    const actions = MODULE_ACTIONS[module] || []
    actions.forEach((action) => {
      const bucket = actionStorageModule(action, module)
      if (!editor[bucket]) editor[bucket] = {}
      editor[bucket][action.key] = stored[bucket]?.[action.key] === true
    })
  })

  return editor
}

/**
 * Monta payload para salvar no banco com true/false explícito em cada ação da UI.
 */
export function buildPermissionsForSave(editorPermissions = {}) {
  const payload = {}

  Object.values(MODULES).forEach((module) => {
    if (!payload[module]) payload[module] = {}
    const actions = MODULE_ACTIONS[module] || []
    actions.forEach((action) => {
      const bucket = actionStorageModule(action, module)
      if (!payload[bucket]) payload[bucket] = {}
      payload[bucket][action.key] = editorPermissions[bucket]?.[action.key] === true
    })
  })

  return normalizeSalesPermissions(payload)
}

/**
 * Remove apenas sales.view (legado oculto) que liberava páginas granulares via fallback.
 * create/update são permissões ativas na UI (Criar/Editar Venda).
 */
export function normalizeSalesPermissions(permissions) {
  if (!permissions || typeof permissions !== 'object') {
    return permissions || {}
  }

  const normalized = { ...permissions }
  const sales = normalized[MODULES.SALES]
  if (!sales || typeof sales !== 'object') {
    return normalized
  }

  const cleanSales = { ...sales }
  delete cleanSales[ACTIONS.VIEW]
  normalized[MODULES.SALES] = cleanSales
  return normalized
}

function hasSalesDataReadAccess(sales) {
  if (sales[ACTIONS.SALES_PRESALE] === true) return true
  if (sales[ACTIONS.SALES_PDV_VIEW] === true) return true
  if (sales[ACTIONS.SALES_RELATION_VIEW] === true) return true
  if (sales[ACTIONS.SALES_PRESALE_LIST_VIEW] === true) return true
  if (sales[ACTIONS.SALES_ONLINE_VIEW] === true) return true
  if (sales[ACTIONS.SALES_NFE_VIEW] === true) return true
  return false
}

/**
 * Verifica permissão de vendas (inclui legado view/create/update/delete)
 */
export function resolveSalesPermission(permissions, action) {
  const sales = permissions?.[MODULES.SALES]
  if (!sales) {
    return false
  }
  if (sales[action] === true) {
    return true
  }

  if (action === ACTIONS.SALES_DATA_READ) {
    return hasSalesDataReadAccess(sales)
  }

  if (action === ACTIONS.SALES_NFE_CREATE && sales[ACTIONS.CREATE] === true) {
    return true
  }
  if (action === ACTIONS.SALES_NFE_UPDATE && sales[ACTIONS.UPDATE] === true) {
    return true
  }
  if (
    action === ACTIONS.SALES_SPECIAL_TABLES_MANAGE &&
    (sales[ACTIONS.CREATE] === true || sales[ACTIONS.UPDATE] === true || sales[ACTIONS.DELETE] === true)
  ) {
    return true
  }

  if (action === ACTIONS.SALES_ONLINE_UPDATE && sales[ACTIONS.UPDATE] === true) {
    return true
  }
  if (action === ACTIONS.SALES_ONLINE_DELETE && sales[ACTIONS.DELETE] === true) {
    return true
  }

  return false
}

